import { useEffect, useRef } from 'react';

export function useDeferredCleanupEffect(setup: () => void, cleanup: () => void): void {
  const cleanupHandleRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (cleanupHandleRef.current !== null) {
      clearTimeout(cleanupHandleRef.current);
      cleanupHandleRef.current = null;
    }
    setup();

    return () => {
      cleanupHandleRef.current = setTimeout(() => {
        cleanupHandleRef.current = null;
        cleanup();
      }, 0);
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- intentionally fires once per mount
  }, []);
}
